import { CorrespondenceCompanyDto } from '@cradua/data';
import { createAction, props } from '@ngrx/store';

/**
 * Load Countries Collection Actions
 */
export const loadCorrespondenceCompany = createAction(
  '[CorrespondenceCompany] Load CorrespondenceCompany'
);

export const loadCorrespondenceCompanySuccess = createAction(
  '[CorrespondenceCompany] Load CorrespondenceCompany Success',
  props<{ correspondenceCompany: CorrespondenceCompanyDto[] }>()
);

export const loadCorrespondenceCompanyFailure = createAction(
  '[CorrespondenceCompany] Load CorrespondenceCompany Failure',
  props<{ error: any }>()
);

/**
 * Add Countries to Collection Actions
 */
export const addCorrespondenceCompany = createAction(
  '[CorrespondenceCompany] Add CorrespondenceCompany',
  props<{ newCorrespondenceCompany: CorrespondenceCompanyDto[] }>()
);

export const addCorrespondenceCompanySuccess = createAction(
  '[CorrespondenceCompany] Add CorrespondenceCompany Success',
  props<{ newCorrespondenceCompany: CorrespondenceCompanyDto[] }>()
);

export const addCorrespondenceCompanyFailure = createAction(
  '[CorrespondenceCompany] Add CorrespondenceCompany Failure',
  props<{ error: any }>()
);

/**
 * Update CorrespondenceCompany Collection Actions
 */
export const updateCorrespondenceCompany = createAction(
  '[CorrespondenceCompany] Update CorrespondenceCompany',
  props<{ updateCorrespondenceCompany: CorrespondenceCompanyDto[] }>()
);

export const updateCorrespondenceCompanySuccess = createAction(
  '[CorrespondenceCompany] Update CorrespondenceCompany Success',
  props<{ updateCorrespondenceCompany: CorrespondenceCompanyDto[] }>()
);

export const updateCorrespondenceCompanyFailure = createAction(
  '[CorrespondenceCompany] Update CorrespondenceCompany Failure',
  props<{ error: any }>()
);

/**
 * Remove CorrespondenceCompany Collection Actions
 */
export const removeCorrespondenceCompany = createAction(
  '[CorrespondenceCompany] Remove CorrespondenceCompany',
  props<{ ids: string[] }>()
);

export const removeCorrespondenceCompanySuccess = createAction(
  '[CorrespondenceCompany] Remove CorrespondenceCompany Success',
  props<{ ids: string[] }>()
);

export const removeCorrespondenceCompanyFailure = createAction(
  '[CorrespondenceCompany] Remove CorrespondenceCompany Failure',
  props<{ error: any }>()
);
